import React from "react";
import "./CustomCheckBoxInput.scss";
import Typhography from "../Typhography/Typhography";
import { objectToClassString } from "../../utils/functions";
import CheckIcon from "../../assets/icons/CheckIcon";

interface ICustomCheckBoxInput<
  T extends readonly Record<"label" | "value", string>[]
> {
  label?: string;
  value?: string[];
  onChange: (value: T[number]["value"][]) => void;
  options: T;
}

const CustomCheckBoxInput = <
  T extends readonly Record<"label" | "value", string>[]
>({
  label,
  options,
  onChange,
  value = [],
}: ICustomCheckBoxInput<T>) => {
  const onSelect = (item: T[number]) => {
    const indexElement = value.findIndex(
      (valueItem) => valueItem === item.value
    );
    onChange(
      indexElement < 0
        ? [...value, item.value]
        : value.filter((valueItem) => valueItem !== item.value)
    );
  };

  const renderRadio = (option: ICustomCheckBoxInput<T>["options"][0]) => (
    <div
      className="container__checkbox"
      key={option.value}
      onClick={() => onSelect(option as T[number])}
    >
      <div
        className={`container__square ${objectToClassString({
          selected: value.includes(option.value),
        })}`}
      >
        <CheckIcon className="check__icon" />
      </div>
      <Typhography type="span" size="medium-14">
        {option.label}
      </Typhography>
    </div>
  );

  return (
    <div className="container__custom__checkbox__input">
      <Typhography size="bold-14">{label}</Typhography>
      <div className="container__group__checkbox">
        {options.map((option) => renderRadio(option))}
      </div>
    </div>
  );
};

export default CustomCheckBoxInput;
